import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ClubPlanListApi = (ID, data) => API.get(`${URL.CLUB_PLAN_LIST}/${ID}`, data)
export const PlansDetailApi = (ID, data) => API.get(`${URL.PLAN_DETAIL}/${ID}`, data)
